import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// From apis
import {
  authApi,
  buildingsApi,
  cookieApi,
  decalApi,
  employeesApi,
  metricsApi,
  notificationsApi,
  onboardingApi,
  serviceInterruptionsApi,
  feedbackApi,
  orgApi,
  searchApi,
  userApi,
  usersApi,
  zonesApi,
  zoneCategoriesApi,
} from 'store/apis';

// From slices
import { authSlice, layoutSlice, visualizationSlice } from 'store/slices';

const authSlicePersistConfig = {
  key: 'cleancode-auth',
  storage,
  blacklist: [],
};

export const appReducer = combineReducers({
  /**
   * From apis
   */
  [authApi.reducerPath]: authApi.reducer,
  [buildingsApi.reducerPath]: buildingsApi.reducer,
  [cookieApi.reducerPath]: cookieApi.reducer,
  [decalApi.reducerPath]: decalApi.reducer,
  [employeesApi.reducerPath]: employeesApi.reducer,
  [metricsApi.reducerPath]: metricsApi.reducer,
  [notificationsApi.reducerPath]: notificationsApi.reducer,
  [onboardingApi.reducerPath]: onboardingApi.reducer,
  [serviceInterruptionsApi.reducerPath]: serviceInterruptionsApi.reducer,
  [feedbackApi.reducerPath]: feedbackApi.reducer,
  [orgApi.reducerPath]: orgApi.reducer,
  [searchApi.reducerPath]: searchApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [usersApi.reducerPath]: usersApi.reducer,
  [zonesApi.reducerPath]: zonesApi.reducer,
  [zoneCategoriesApi.reducerPath]: zoneCategoriesApi.reducer,

  /**
   * From slices
   */
  [authSlice.name]: persistReducer(authSlicePersistConfig, authSlice.reducer),
  [layoutSlice.name]: layoutSlice.reducer,
  [visualizationSlice.name]: visualizationSlice.reducer,
});
